var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreaterRoi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.43,
    height: 42.429,
    viewBox: "0 0 42.43 42.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refund_8831351",
    transform: "translate(-433.005 -241.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OUTLINE",
    transform: "translate(433.005 241.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M440.037,246.438l-1.185-.736a3.112,3.112,0,0,0-4.753,2.742l.143,4.48a3.111,3.111,0,0,0,4.4,2.734l4.081-1.855a3.112,3.112,0,0,0,.355-5.476l-.522-.324a18.4,18.4,0,1,1-6.428,10.948,1.415,1.415,0,1,0-2.785-.5,21.217,21.217,0,1,0,6.7-12.014Zm-2.968,6.4-.143-4.48a.284.284,0,0,1,.141-.255.281.281,0,0,1,.29,0l4.224,2.627a.28.28,0,0,1,.133.257.286.286,0,0,1-.165.24l-4.081,1.855a.282.282,0,0,1-.266-.018.279.279,0,0,1-.133-.231Z",
    transform: "translate(-433.005 -241.006)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M447.829,252.842a3.11,3.11,0,0,0-2.829,3.1v.849a3.11,3.11,0,0,0,3.112,3.112h2.263a.285.285,0,0,1,.283.283v.849a.285.285,0,0,1-.283.283h-3.961a1.415,1.415,0,1,0,0,2.829h1.415v1.415a1.415,1.415,0,1,0,2.829,0v-1.427a3.11,3.11,0,0,0,2.829-3.1v-.849a3.11,3.11,0,0,0-3.112-3.112h-2.263a.285.285,0,0,1-.283-.283v-.849a.285.285,0,0,1,.283-.283h3.961a1.415,1.415,0,0,0,0-2.829h-1.415v-1.415a1.415,1.415,0,1,0-2.829,0Z",
    transform: "translate(-428.032 -237.277)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(8.306 8.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M177.313,54.959a12.722,12.722,0,1,0,12.722,12.722A12.728,12.728,0,0,0,177.313,54.959Zm0,2.827a9.895,9.895,0,1,1-9.895,9.895A9.9,9.9,0,0,1,177.313,57.786Z",
    transform: "translate(-164.591 -54.959)",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterRoi);
export default __webpack_public_path__ + "static/media/greaterRoi.88b5441787da9d8fc53e53ea784b8557.svg";
export { ForwardRef as ReactComponent };